import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormArray, UntypedFormControl, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { TypZaznamuTextu } from '../model/typ-zaznamu-textu';
import { ErrorDialogComponent } from 'projects/ais-common/src/public-api';
import { MatDialog } from '@angular/material/dialog';
import { AppStateService } from '../app-state.service';
import { FormService } from '../form.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-select-typ',
    templateUrl: './select-typ.component.html',
    styleUrls: ['./select-typ.component.css'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    standalone: false
})
export class SelectTypComponent implements OnInit {

  @Input() kodJazykIN: string;
  @Input() typZaznamuTextu: TypZaznamuTextu;
  @Input() indexPolozkyVoFormulari: number;

  @Input() formularFormGroup: UntypedFormGroup;

  formArrayJazyk1: UntypedFormArray = new UntypedFormArray([]);
  formArrayJazyk2: UntypedFormArray = new UntypedFormArray([]);
  formArrayJazyk3: UntypedFormArray = new UntypedFormArray([]);

  zobrazitHelpTextSK = false;
  zobrazitHelpTextEN = false;

  pocetPoloziekJazyk1: number = 0;
  pocetPoloziekJazyk2: number = 0;
  pocetPoloziekJazyk3: number = 0;

  pocetPridanychPoloziekJazyk1: number = 0;
  pocetPridanychPoloziekJazyk2: number = 0;
  pocetPridanychPoloziekJazyk3: number = 0;

  jazykyFormularaPole: string[] = [];
  jazykFormulara1: string = 'SK';
  jazykFormulara2: string = '';
  jazykFormulara3: string = '';
  existujeVoFormulariJazyk2 = false;
  existujeVoFormulariJazyk3 = false;

  mapaJazykovAFormArrays: Map<string, UntypedFormArray> = new Map();

  jeOpakovaniePodprogramu: boolean;

  constructor(public dialog: MatDialog,
    public appStateService: AppStateService,
    public formService: FormService,
    private translateService: TranslateService) { }

  ngOnInit(): void {

    this.jazykyFormularaPole = this.appStateService.jazykyFormulara;
    this.jazykFormulara1 = this.jazykyFormularaPole[0];
    if (this.jazykyFormularaPole.length >= 2) {
      this.jazykFormulara2 = this.jazykyFormularaPole[1];
      this.existujeVoFormulariJazyk2 = true;
    }
    if (this.jazykyFormularaPole.length >= 3) {
      this.jazykFormulara3 = this.jazykyFormularaPole[2];
      this.existujeVoFormulariJazyk3 = true;
    }

    this.jeOpakovaniePodprogramu = this.appStateService.jeOpakovaniePodprogramu(this.typZaznamuTextu);

    if (this.typZaznamuTextu.opakovanie === 'A' || this.jeOpakovaniePodprogramu) {

      const menoArrayControlsu:string = 'name_' + this.typZaznamuTextu.id + '_' + this.jazykFormulara1;
      this.formArrayJazyk1 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsu);
      this.pocetPoloziekJazyk1 = this.formArrayJazyk1.length;
      // pocet pridanych poloziek oproti minimu (minPocet)
      this.pocetPridanychPoloziekJazyk1 = this.formArrayJazyk1.length - this.typZaznamuTextu.minPocet;

      if (this.existujeVoFormulariJazyk2) {
        const menoArrayControlsuJazyk2: string = 'name_' + this.typZaznamuTextu.id + '_' + this.jazykFormulara2;
        this.formArrayJazyk2 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsuJazyk2);
        this.pocetPoloziekJazyk2 = this.formArrayJazyk2.length;
        // pocet pridanych poloziek oproti minimu (minPocet)
        this.pocetPridanychPoloziekJazyk2 = this.formArrayJazyk2.length - this.typZaznamuTextu.minPocet;
      }

      if (this.existujeVoFormulariJazyk3) {
        const menoArrayControlsuJazyk3: string = 'name_' + this.typZaznamuTextu.id + '_' + this.jazykFormulara3;
        this.formArrayJazyk3 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsuJazyk3);
        this.pocetPoloziekJazyk3 = this.formArrayJazyk3.length;
        // pocet pridanych poloziek oproti minimu (minPocet)
        this.pocetPridanychPoloziekJazyk3 = this.formArrayJazyk3.length - this.typZaznamuTextu.minPocet;
      }

    }

    this.mapaJazykovAFormArrays.set(this.jazykyFormularaPole[0], this.formArrayJazyk1);
    if (this.existujeVoFormulariJazyk2) {
      this.mapaJazykovAFormArrays.set(this.jazykyFormularaPole[1], this.formArrayJazyk2);
    }
    if (this.existujeVoFormulariJazyk3) {
      this.mapaJazykovAFormArrays.set(this.jazykyFormularaPole[2], this.formArrayJazyk3);
    }


  }

  getTooltip(kodJazyk: string, indexPolozkyVoFormulari?: number): string {
    let menoControlsu = null;
    if (this.typZaznamuTextu.idSkupina) {
      menoControlsu = 'name_' + this.typZaznamuTextu.idSkupina + '_' + kodJazyk;
    } else {
      menoControlsu = 'name_' + this.typZaznamuTextu.id + '_' + kodJazyk;
    }

    if (indexPolozkyVoFormulari !== null) {
      // ak ide o opakovanu alebo skupinovu polozku
      if ((<UntypedFormArray>this.formularFormGroup.get(menoControlsu)).controls) {
        return (<UntypedFormArray>this.formularFormGroup.get(menoControlsu)).controls[indexPolozkyVoFormulari]?.value;
      }
    }

    return this.formularFormGroup.get(menoControlsu).value;
  }

  pridatPolozku(jazyk: string){
    if (!(this.typZaznamuTextu.podprogram === 1)) {
      this.pocetPoloziekJazyk1 = this.formArrayJazyk1.length;
      this.pocetPoloziekJazyk2 = this.formArrayJazyk2.length;
      this.pocetPoloziekJazyk3 = this.formArrayJazyk3.length;
      const text = this.translateService.instant('Už je pridaný maximálny povolený počet položiek.');
      if (jazyk === this.jazykFormulara1) {
        if (this.pocetPoloziekJazyk1 >= this.typZaznamuTextu.maxPocet) {
          this.openErrorDialog(text);
          return;
        }
      } else if (jazyk === this.jazykFormulara2) {
        if (this.pocetPoloziekJazyk2 >= this.typZaznamuTextu.maxPocet) {
          this.openErrorDialog(text);
          return;
        }
      } else if (jazyk === this.jazykFormulara3) {
        if (this.pocetPoloziekJazyk3 >= this.typZaznamuTextu.maxPocet) {
          this.openErrorDialog(text);
          return;
        }
      }
    }

    const name = 'name_' + this.typZaznamuTextu.id + '_' + jazyk;
    const control = new UntypedFormControl('');
    (<UntypedFormArray>this.formularFormGroup.get(name)).push(control);
    if (jazyk === this.jazykFormulara1) {
      // this.formArraySK.push(control);
      this.pocetPoloziekJazyk1++;
      this.pocetPridanychPoloziekJazyk1++;
    } else if (jazyk === this.jazykFormulara2) {
      // this.formArrayEN.push(control);
      this.pocetPoloziekJazyk2++;
      this.pocetPridanychPoloziekJazyk2++;
    } else if (jazyk === this.jazykFormulara3) {
      // this.formArrayEN.push(control);
      this.pocetPoloziekJazyk3++;
      this.pocetPridanychPoloziekJazyk3++;
    }
    // console.log('this.formArraySK: ' + this.formArrayJazyk1.length);
    // console.log('this.pocetPoloziekSK: ' + this.pocetPoloziekJazyk1);
    // console.log('this.pocetPridanychPoloziekSK: ' + this.pocetPridanychPoloziekJazyk1);
  }

  openErrorDialog(msg: string) {
    this.dialog.open(ErrorDialogComponent, {
      panelClass: 'alert-danger',
        data: {message: msg},
        width: '500px',
      });
  }

  getPolozkyCiselnika(jazyk: string): string[] {
    let result: string[] = null;
    switch (jazyk) {
      case this.jazykFormulara1:
        result = this.typZaznamuTextu.polozkyCiselnika;
        break;
      case this.jazykFormulara2:
        result = this.typZaznamuTextu.polozkyCiselnikaJazyk2;
        break;
      case this.jazykFormulara3:
        result = this.typZaznamuTextu.polozkyCiselnikaJazyk3;
        break;

      default:
        result = this.typZaznamuTextu.polozkyCiselnika;
        break;
    }

    return result;
  }

  getPridatPolozkuTooltip() {
    let result
      = this.translateService.instant('Pridať položku') + ' ('
        + this.translateService.instant('max. počet je') +  ' ' + this.typZaznamuTextu.maxPocet + ')';
    if (this.typZaznamuTextu.opakovanie !== 'A' && this.typZaznamuTextu.podprogram === 1) {
      result = this.translateService.instant('Pridať položku');
    }

    return result;
  }

    // indexDruhejPolozky - index druhej polozky z tych dvoch poloziek, ktore medzi sebou vymienam
    vymenPolozky(indexDruhejPolozky: number, kodJazyk: string) {

      this.formService.vymenPolozky(this.formularFormGroup,
        this.typZaznamuTextu, indexDruhejPolozky, kodJazyk)

    }

    getVymenitObsahPoloziekTooltip() {
      return this.translateService.instant('Vymeniť obsah položiek');
    }

}
